import React, {PureComponent, ReactNode} from 'react'

type BulletPointProps = {
    text: String,
    children?: ReactNode
}

export class BulletPoint extends PureComponent<BulletPointProps> {
    render(): ReactNode {
        return (
            <div>
                <div className="flex items-top ml-1 mb-3">
                    <div className="mr-4 relative top-1 min-w-[15px] flex justify-center">
                        {this.props.children}
                    </div>
                    <div dangerouslySetInnerHTML={{__html: this.props.text}}/>
                </div>
            </div>
        )
    }
}
